import(/* webpackMode: "eager" */ "/app/src/app/[locale]/(home)/error.tsx")